module.exports = __webpack_public_path__ + "b97129340bc9769a0bc2dad68109deaa.svg";